var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-select',{attrs:{"field":"state","label":null,"manual-doc":_vm.manualDoc,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }